import script from "./SyncProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncProgress.vue?vue&type=script&setup=true&lang=js"

import "./SyncProgress.vue?vue&type=style&index=0&id=79c1d314&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c1d314"]])

export default __exports__